export default __webpack_public_path__ + "static/assets/9f8688afc5f84878273a4bed2f9a9dcb.png";